export default "__VITE_ASSET__DmBR3aMT__"